import SdsCard from "@salesforce-ux/sds-components/src/card/card";
import css from "./card.css";

export default class FooCard extends SdsCard {
  connectedCallback() {
    super.connectedCallback();
    this.shadowRoot.innerHTML += `<style>${css}</style>`;
  }
}
